import { Story } from '../../types/story';

export const istanbulCafe: Story = {
  id: 'istanbul-cafe',
  title: 'The Regular',
  excerpt: 'A young director becomes obsessed with the woman who runs the tiny café where he writes his scripts, until one late night changes everything.',
  city: 'Istanbul',
  publishDate: '2026-01-03',
  readTime: '12 min read',
  tags: ['♂♀', 'café', 'slow-burn', 'intimate'],
  categories: ['romantic'],
  intensity: 2,
  content: `My café is the size of a shoebox. Six tables, an espresso machine I bought secondhand, walls painted the color of strong tea. It's tucked into a side street in Karaköy, the kind of place you'd walk past unless you knew to look for it.

I opened it three years ago with money I'd saved working at corporate coffee chains, the ones that spell your name wrong and play the same playlist on loop. This place is different. No wifi password on the wall, no Instagram-friendly neon signs. Just good coffee and the sound of the Bosphorus fog horns on winter mornings.

Most of my customers are regulars. The architect who takes his cortado at 7 AM sharp. The translator who camps out all afternoon with her laptop. The old man who reads Cumhuriyet and argues with himself about politics.

And then there's him.

He started coming in about two months ago. Always around 10 AM, always ordering the same thing—double espresso, no sugar, glass of water on the side. He'd take the table by the window, pull out a battered notebook, and write for hours. Sometimes he'd stare at the street like he was waiting for it to tell him something.

I noticed him because he was beautiful in that careless way some men are—dark hair that needed cutting, a leather jacket worn soft at the elbows, hands that moved when he talked on the phone like he was directing an invisible film. Which, it turned out, he was.

"I'm a director," he said one morning when I brought his espresso. "Well, trying to be. This is my third script. The first two were terrible."

"What's this one about?"

"A woman who runs a café." He smiled, and it changed his whole face. "I'm doing research."

"Is that what you call sitting here for four hours?"

"I call it observation. You're very particular about how you make coffee."

"It's my café. I'm allowed to be particular."

"I like particular." He held out his hand. "I'm Kerem."

"Ayşe."

After that, we talked. Small conversations at first—about the neighborhood, about the film he was trying to make, about why I'd opened a café when everyone said it was financial suicide.

"Because I wanted something that was mine," I told him. "Something I built. Even if it's small."

"Small isn't bad. Small can be perfect."

He kept coming back. Same time, same table, same order. But now he'd look up when I walked past, ask me questions about the espresso blend I used, tell me about the scene he was stuck on.

"It's the ending," he said one afternoon, frustrated. "I can't figure out how they get together. It feels forced."

"Maybe they don't get together."

"That's depressing."

"Or honest." I refilled his water glass. "Not everything has to resolve neatly."

"You sound like my film professor."

"Is that a compliment?"

"I'm still deciding."

The thing about running a café is you see people at their most unguarded. Before coffee, after breakups, during the quiet moments when they think no one's watching. I watched Kerem struggle with his script, watched him take phone calls that made his jaw tight, watched him smile at his screen when something finally worked.

And I started to wonder what it would be like to be the reason for that smile.

It was a Tuesday night, raining hard, when everything shifted. I was supposed to close at 8, but I was behind on inventory, so I was still there at 10 when someone knocked on the door.

Kerem, soaked through, holding his notebook over his head like an umbrella.

"We're closed," I said, but I unlocked the door anyway.

"I know. I'm sorry. I was walking and I saw your light on and—" He stopped. "I finished it. The script. I wanted to tell you."

"That's great."

"You're in it. I mean, not you exactly, but—the café owner. She's the main character. I couldn't figure out the ending until I realized it wasn't about the romance. It was about her choosing herself."

I didn't know what to say. He was dripping on my floor, looking at me like I'd given him something instead of just making his coffee for two months.

"Do you want to read it?" he asked.

"Now?"

"If you're not busy."

I made us both coffee—a real one, the kind I make for myself, not customers. We sat at his usual table, and I read while he pretended not to watch my face.

It was good. Really good. The café owner was sharp, complicated, someone who'd chosen a small life deliberately, not because she'd failed at a big one. And the ending—she didn't end up with the writer character. She ended up with herself, and it felt right.

"This is beautiful," I said when I finished.

"You think so?"

"I know so. You should make this."

"I'm trying. I submitted it to a grant program. If I get it, I can actually shoot it." He ran his hand through his wet hair. "I wanted you to read it first. Before anyone else."

"Why?"

"Because you inspired it. Because you're the reason I kept coming back here. Not just for the coffee."

The rain was still falling outside. The café was warm, quiet, just the two of us and the espresso machine's idle hum.

"Kerem—"

"I know. You're working. I should go. I just wanted—"

I kissed him.

I didn't plan it. Didn't think about it. I just leaned across the table and kissed him, and he made this small surprised sound before kissing me back.

His mouth tasted like coffee and rain. His hand came up to cup my face, gentle, like I was something that might break. When we pulled apart, we were both breathing hard.

"I've wanted to do that for weeks," I said.

"I've wanted you to do that for weeks."

"Why didn't you say something?"

"Because you're busy. Because I'm broke and trying to make a film that'll probably never get made. Because I didn't want to be another guy hitting on you at work."

"You're not another guy."

"No?"

"No." I stood up, held out my hand. "Come on."

"Where?"

"Upstairs. I live above the café."

My apartment was small, messy, full of coffee samples and books I kept meaning to read. Kerem didn't seem to notice. He was too busy kissing me, backing me toward the couch, his hands in my hair.

"Is this okay?" he asked, breathless.

"Yes. Don't stop."

We didn't make it to the bedroom. We barely made it to the couch. His jacket hit the floor, then my sweater, then everything else, until we were tangled together, learning each other.

He touched me like he was memorizing me—slow, deliberate, paying attention to what made me gasp, what made me arch into his hands. When he moved down my body, kissing a trail from my neck to my stomach, I stopped thinking about anything except the feeling of his mouth on my skin.

"Tell me what you want," he murmured against my hip.

"You. I want you."

He took his time, his tongue and fingers working together until I was trembling, my hands fisted in his hair. When I came, it was with his name on my lips, my body clenching around his fingers.

He crawled back up, kissed me deep so I could taste myself on his tongue. I reached between us, wrapped my hand around him, and he groaned into my mouth.

"Condom?" I asked.

"Wallet. Back pocket."

I found it, rolled it on while he watched, his eyes dark with want. Then I pulled him down, guided him inside me, and we both made these broken sounds as he filled me.

He moved slow at first, letting me adjust, his forehead pressed to mine. Then I wrapped my legs around him, pulled him deeper, and he got the message. His rhythm picked up, each thrust hitting exactly right, building that tension again.

"Touch yourself," he said, his voice rough. "I want to feel you come around me."

I slid my hand between us, found my clit, and the added sensation made me moan. He watched my face, his hips never stopping, and when I came again, he followed, burying himself deep with a groan.

We lay there afterward, sticky and breathless, the rain still falling outside.

"Stay," I said. "Tonight."

"I don't want to impose—"

"You're not. Stay."

He did. We moved to the bed eventually, made love again in the early morning, slower this time, learning what the first time had been too urgent to discover.

When the sun came up, I made us coffee in my tiny kitchen. He sat at my counter in his boxers, watching me work.

"I got the grant," he said suddenly.

"What?"

"The email came through last night. Before I came here. I got the funding. I'm making the film."

"Kerem, that's incredible!"

"I want you to be in it. Not as an actress—I know that's not your thing. But I want to shoot some scenes here, in the café. If you'll let me."

"Of course."

"And I want to keep coming here. Not just for the film. For this." He gestured between us. "If you want that too."

I thought about it. About the risk of mixing my careful, small life with someone whose dreams were big and uncertain. About what it would mean to let someone in.

"I want that," I said.

He did keep coming. Every morning, same table, same order. But now he'd kiss me when he arrived, help me close up at night, stay over more often than not.

The film shoot was chaos—lights and cameras crammed into my tiny café, Kerem directing with an intensity that was magnetic to watch. When it premiered at a festival six months later, I went with him, held his hand while the audience laughed and cried in all the right places.

"You did it," I said afterward.

"We did it." He pulled me close. "None of this happens without you."

The café is still small. Still tucked into that side street in Karaköy. But now there's a framed poster from Kerem's film on the wall, and sometimes tourists come in asking if this is the place from the movie.

It is. But it's also just mine. My small, perfect thing. 

And some mornings, when Kerem takes his usual table with his usual order, I catch him watching me make coffee with that same look he had the first time—like he's still doing research, still trying to figure out the ending.

I don't tell him I already know how it ends. Some things are better as mysteries.`
};
